import React, { useState, useEffect } from "react";
import { Box, Flex, Heading, VStack, Progress } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";
import { FaDna } from "react-icons/fa";

const MotionBox = motion(Box);
const MotionFlex = motion(Flex);

const SplashScreen = ({ onFinish }) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => {
            setIsVisible(false);
            if (onFinish) onFinish();
          }, 250);
          return 100;
        }
        return prev + 10;
      });
    }, 40);

    return () => clearInterval(timer);
  }, [onFinish]);

  return (
    <AnimatePresence>
      {isVisible && (
        <MotionFlex
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          zIndex="99999"
          bg="#0b1329"
          color="white"
          align="center"
          justify="center"
          direction="column"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.5, ease: "easeInOut" } }}
        >
          {/* Subtle Ambient Glow */}
          <Box
            position="absolute"
            w="400px"
            h="400px"
            borderRadius="full"
            bg="radial-gradient(circle, rgba(13, 148, 136, 0.25) 0%, rgba(11, 19, 41, 0) 70%)"
            pointerEvents="none"
          />

          <VStack spacing="24px" zIndex="1" maxW="280px" w="85%" textAlign="center">
            {/* Animated Icon Ring */}
            <Box position="relative" w="80px" h="80px" display="flex" alignItems="center" justifyContent="center">
              <MotionBox
                position="absolute"
                w="80px"
                h="80px"
                borderRadius="full"
                border="2px dashed"
                borderColor="teal.400"
                animate={{ rotate: 360 }}
                transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
              />
              <MotionBox
                animate={{ scale: [1, 1.12, 1] }}
                transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
              >
                <FaDna size="30px" color="#0d9488" />
              </MotionBox>
            </Box>

            {/* Clean Title */}
            <Heading size="md" fontWeight="800" letterSpacing="0.05em" color="white" textTransform="uppercase">
              TUNISIAN XP DATABASE
            </Heading>

            {/* Minimal Thin Progress Line */}
            <Box w="100%">
              <Progress
                value={progress}
                size="xs"
                w="100%"
                borderRadius="full"
                colorScheme="teal"
                bg="whiteAlpha.100"
              />
            </Box>
          </VStack>
        </MotionFlex>
      )}
    </AnimatePresence>
  );
};

export default SplashScreen;

